import React from 'react'

import './style.scss'

class Notification extends React.PureComponent {

  render() {
    return (
      <div className="notification">
        Playpost will stop its service on the 25th of December 2020
      </div>
    )
  }
}

export default Notification
